import React from 'react';
import type { ForwardRefExoticComponent, RefAttributes, SVGProps } from 'react';
import Button from '../button/Button';
import clsx from 'clsx';

export type HeroIconComponent = ForwardRefExoticComponent<
  SVGProps<SVGSVGElement> & { title?: string; titleId?: string } & RefAttributes<SVGSVGElement>
>;

export type TabBarItem = {
  icon: HeroIconComponent;
  title: string;
  onClick: () => void;
  disabled?: boolean;
};

export interface TabBarProps {
  items: TabBarItem[];
}

export const TabBar: React.FC<TabBarProps> = ({ items }) => {
  const itemCount = items.length;

  return (
    <div className="flex w-full flex-wrap justify-center gap-4 bg-gray-100">
      {items.map(({ title, onClick, icon: Icon, disabled }, idx) => {
        const buttonClassName = clsx('grow', {
          'basis-full': itemCount === 1 || (itemCount === 3 && idx === 2),

          'basis-[calc(50%-0.5rem)]':
            itemCount === 2 || (itemCount === 3 && idx < 2) || itemCount >= 4,
        });

        return (
          <Button
            key={String(idx)}
            title={title}
            onClick={onClick}
            disabled={disabled ?? false}
            startIcon={<Icon className="size-5" />}
            className={buttonClassName}
          />
        );
      })}
    </div>
  );
};
